import { masterServices } from "./masterServices";
import { appServices } from "./appServices";

export const services = {
  ...masterServices,
  ...appServices,
}